<script lang="ts">
  // libs
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";

  // components
  import SpecialDiscount from "@retailer/svelte/Cart/Page/DistributorSection/SpecialDiscount.svelte";
  import DepositInfo from "@retailer/svelte/Cart/Page/DistributorSection/DepositInfo.svelte";
  import CartProductDealDescription from "@shared/svelte/Components/Deal/CartProductDealDescription.svelte";

  // types
  import type { CartProduct } from "@shared/types/ProductLine";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";

  // stores
  import StateSettingsStore from "@shared/svelte/Stores/StateSettingsStore";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";

  // props
  export let product: CartProduct;

  // reactives
  $: isMobile = $LayoutStore.isMobile;
  $: hasDiscount = product.discount_amount > 0;
  $: showSpecialDiscount =
    !$StateSettingsStore["uses_future_pricing_with_min_bottle"] &&
    product.discounts &&
    product.discounts.length > 0 &&
    !product.deleted;

  function isPriceUnavailable() {
    let price = product.discount_amount > 0 ? product.total : product.subtotal;

    return price == 0 || isNaN(parseFloat(String(price)));
  }
</script>

<div data-testid="product-total">
  {#if isPriceUnavailable()}
    <div
      class="fizz-text-small fizz-text-subdued"
      class:fizz-align-self-start={!isMobile}
      class:fizz-text-right={!isMobile}
    >
      Price not available
    </div>
  {:else}
    <div class="fizz-text-eyebrow">
      {#if product.has_custom_price}
        CUSTOM PRICE
      {/if}
    </div>
    {#if hasDiscount}
      <div class="fizz-text-deal price-string">
        <strong><FormatMoney input={product.total} /></strong>
      </div>
    {/if}
    {#if !hasDiscount || !$StateSettingsStore["uses_future_pricing_with_min_bottle"]}
      <span
        class:strikethrough={hasDiscount}
        class:fizz-text-subdued={hasDiscount}
        class:fizz-text-small={hasDiscount}
        class:fizz-text-strong={!hasDiscount}
        class:price-string={!hasDiscount}
      >
        <FormatMoney input={product.subtotal} />
      </span>
    {/if}
    {#if showSpecialDiscount}
      <SpecialDiscount {product} />
    {/if}
    <DepositInfo cartProduct={product} />
    {#if !$StateSettingsStore["uses_future_pricing_with_min_bottle"]}
      <CartProductDealDescription bind:cartProduct={product} />
    {/if}
  {/if}
</div>
